import Vue from 'vue'
import title from './fragments/title'

const area = 'dashboard.cardAppointment.'
const translate = (data) => Vue.i18n.translate(data)

const additionalData = (data) => {
  const additionalData = data.additional_data

  if (!additionalData || additionalData.length <= 0) return ''

  let additionalDataContentAsString =  ''


  additionalData.forEach((data) => {
    additionalDataContentAsString += `
      <h6 class="text-uppercase grey--text">
        ${data.title}
      </h6>
      <p class="body-2 mb-3">
        ${data.value ? data.value : '---'}
      </p>
    `
  })

  return `
    <details>
      ${title(translate(area + 'additionalData'))}
      <content>
        ${additionalDataContentAsString}
      </content>
    </details>
  `
}

export default additionalData
